export default __webpack_public_path__ + "static/media/clip-1771.4fe39bf5.png";